import React from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { Urls } from 'data';
import { useAPI, useGetUser } from 'hooks';
import { Button } from 'components/ui/button';
import { About, Footer, Hero, Journey, Navbar, Pricing, Seats } from './components';
import { loadLandingData } from './data';

const Home = () => {
  const { api } = useAPI();
  const { isConnected, isSuperAdmin, isBank, isPilgrim } = useGetUser();
  const query = useQuery({
    queryKey: ['landing', 'public-data'],
    queryFn: () => loadLandingData(api),
    enabled: !isConnected,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 1,
  });
  if (isConnected) {
    const destination = isSuperAdmin ? Urls.user : isBank ? Urls.invoice : isPilgrim ? Urls.profile.base : Urls.trip;
    return <Navigate to={destination} replace />;
  }
  const data = query.isError ? null : query.data;
  const status = query.isError ? (
    <div className="px-4 py-7 text-center text-[#586357] [&_p]:mb-3" role="status">
      <p className="text-base leading-[inherit] text-inherit">
        Les informations de disponibilité et de tarification sont momentanément indisponibles.
      </p>
      <Button variant="outline" onClick={() => query.refetch()} disabled={query.isFetching}>
        Réessayer
      </Button>
    </div>
  ) : (
    <p className="px-4 py-7 text-center text-[#586357] [&_p]:mb-3" role="status">
      Chargement des informations du pèlerinage…
    </p>
  );
  return (
    <div
      className="bg-[#fafaf8] font-[Inter,sans-serif] text-base leading-[1.65] text-[#30372d] [&_a:focus-visible]:outline [&_a:focus-visible]:outline-[3px] [&_a:focus-visible]:outline-[#9abf70] [&_a:focus-visible]:outline-offset-[5px] [&_section[id]]:scroll-mt-[100px]"
      lang="fr"
    >
      <Helmet>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        />
      </Helmet>
      <Navbar />
      <main className="m-0 w-full max-w-none p-0" id="landing-content" tabIndex={-1}>
        <Hero />
        <About />
        <Seats data={data} status={status} />
        <Journey />
        <Pricing data={data} status={status} />
      </main>
      <Footer year={data?.quota.campaign_year} />
    </div>
  );
};
export default Home;
